module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "指标口径",
      "tags": ['口径说明', '先对齐定义再看图'],
      "chips": _vm.chips,
      "loaded-at": "静态说明，随口径版本更新"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("这几条决定了看板上每个数字怎么算、为什么这么算。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.baseRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("「影响总览」「学生异动影响」两页的事件、波及和事件后结果口径。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.eventRows), function(row) {
    return _c('tr', {
      key: row.type
    }, [_c('td', [_c('span', {
      staticClass: "badge",
      class: row.badge
    }, [_vm._v(_vm._s(row.label))])]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.source))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.date))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.notice))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("离职老师生效日为空不进统计；通知天数小于 0 记 0。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.changeRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("「请假/旷课影响」「学生影响明细」「综合风险视图」三页的口径。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.leaveRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', _vm._l((_vm.studentRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.desc))])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("一期已按下面的「当前处理」上线，业务拍板后再调整。")]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.pendingRows), function(row) {
    return _c('tr', {
      key: row.name
    }, [_c('td', {
      staticClass: "t-name wrap"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.now))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._v(_vm._s(row.todo))])])
  }), 0)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心设计原则")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "note"
  }, [_c('b', [_vm._v("1. 三类事件统一归到「换老师」，不拆链路。")]), _vm._v("离职、淘汰、关闭时间对学生的结果一样——原来那位老师上不了了，得换人。敞口口径统一为未消课时；类型之间的差异只落在"), _c('b', [_vm._v("波及范围")]), _vm._v("（离职 / 淘汰按老师全部学生，关闭时间只看原时段落在关闭区间的学生）和"), _c('b', [_vm._v("通知窗口")]), _vm._v("上。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_c('b', [_vm._v("2. 学生是归因主键，不是老师。")]), _vm._v("一个学生可能同时被多位老师波及，按老师计数会重复。窗口内同一学生被多起事件波及，只归因到生效日最早的一起，其余计「重复受影响」。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note is-danger"
  }, [_c('b', [_vm._v("3. 真正的分水岭是保时换还是改时换。")]), _vm._v("同样换老师，保住原时段和被迫改时间的 30 天留存差距，比「属于哪种异动类型」更能解释留存。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note is-healthy"
  }, [_c('b', [_vm._v("4. 结果指标必须带对照组。")]), _vm._v("异动后 30 天留存单独看没有意义，要和同期未被波及的活跃学生比，差值才是真实影响。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('b', [_vm._v("5. 3 小时内不代课，这个窗口单独看。")]), _vm._v("3 小时内的课节不安排代课，不能和 3 小时外混在一起看代课率，否则整体指标会被 3 小时外拉平，看不出无人兜底的那部分。\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("范围与基础口径")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("项")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("异动事件与波及学生")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("三类异动事件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("类型")]), _c('th', [_vm._v("来源")]), _c('th', [_vm._v("生效日")]), _c('th', [_vm._v("通知天数")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("波及与事件后结果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("请假 / 旷课与学生汇总")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("请假 / 旷课（课节维度）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生事件、状态与风险分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("指标")]), _c('th', [_vm._v("口径")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("待确认口径")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("问题")]), _c('th', [_vm._v("当前处理")]), _c('th', [_vm._v("待拍板")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47a59e7d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/TchImpactModel.vue
// module id = 1794
// module chunks = 8